import { render } from "./ProductoCarrito.vue?vue&type=template&id=0bc2d7ae&scoped=true"
import script from "./ProductoCarrito.vue?vue&type=script&lang=js"
export * from "./ProductoCarrito.vue?vue&type=script&lang=js"

import "./ProductoCarrito.vue?vue&type=style&index=0&id=0bc2d7ae&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc2d7ae"]])

export default __exports__